import { useCallback } from 'react';
import { AsyncRetryReturnType } from 'src/models/company/Security/types';
import { CognitoUser } from 'amazon-cognito-identity-js';
import { Auth } from 'aws-amplify';
import { useAsyncRetry } from 'react-use';

export function useCognitoUser(): AsyncRetryReturnType<CognitoUser> {
  const asyncFunction = useCallback(async () => {
    return await Auth.currentAuthenticatedUser();
  }, []);
  return useAsyncRetry(asyncFunction, [asyncFunction]);
}

export default useCognitoUser;
